import { glideConfig } from "../../library/glide";

// Configuration constants
const DESKTOP_PER_VIEW = 5;
const MOBILE_PER_VIEW = 1;
const GAP = 16;
const MOBILE_BREAKPOINT = 768;

// Multi-instance Editors Picks widget; initializes for each [data-editors-picks-widget]
const editorsPicksSlider = () => {
    // === Slider ===
    const editorsPicks = document.querySelectorAll(
        "[data-editors-picks-plugin] .glide",
    );

    if (editorsPicks.length === 0) return;

    for (const plugin of editorsPicks) {
        const slidesCount = plugin.querySelectorAll(".glide__slide").length;
        const container = plugin.closest("[data-editors-picks-plugin]");
        const skeleton = container?.querySelector(
            "[data-editors-picks-plugin] .editors-picks-skeleton",
        );
        const glide = glideConfig(
            plugin,
            {
                type: "carousel",
                perView: DESKTOP_PER_VIEW,
                gap: GAP,
                dragThreshold: false,
                swipeThreshold: false,
                rewind: false,
                breakpoints: {
                    [MOBILE_BREAKPOINT]: {
                        type:
                            slidesCount <= MOBILE_PER_VIEW
                                ? "slider"
                                : "carousel",
                        perView: MOBILE_PER_VIEW,
                        focusAt: 0,
                        dragThreshold: true,
                        swipeThreshold: true,
                        bound: true,
                        peek: { before: 0, after: 80 },
                    },
                },
            },
            true,
            skeleton,
        );

        // Flip peek when on the last slide
        const updatePeek = () => {
            if (window.innerWidth >= MOBILE_BREAKPOINT) return;

            const perView = glide.settings.perView;
            const lastIndex = glide.settings.bound
                ? Math.floor(slidesCount - perView)
                : slidesCount - 1;

            if (glide.index >= lastIndex) {
                glide.update({ peek: { before: 80, after: 0 } });
            } else {
                glide.update({ peek: { before: 0, after: 80 } });
            }
        };

        glide.on(["mount.after", "run", "resize"], updatePeek);
    }
};

const init = () => {
    editorsPicksSlider();
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
} else {
    init();
}

export { editorsPicksSlider };
